import Vue from "vue";
import Router from "vue-router";
import indexRouter from "./routers/index";
import adminRouter from "./routers/admin";
import userRouter from "./routers/user";
import rechargePackageRouter from "./routers/rechargePackage";
import queryList from "./routers/queryList";
import amountList from "./routers/amountList";
import rechargeRecord from "./routers/rechargeRecord";
import orderManage from "./routers/orderManage";
import articleRouter from "./routers/article";
import articleCategoryRouter from "./routers/article_category";
import operationRouter from "./routers/operation";
import userFeed from "./routers/userFeed";

Vue.use(Router);
export const constantRoutes = [
  {
    path: "/",
    component: () => import("../pages/passport/Login.vue"),
    name: "login",
    meta: { title: "登录页面" }
  },
  {
    path: "/h5/recharge",
    component: () => import("../pages/user/h5Recharge.vue"),
    name: "h5_recharge_standalone",
    meta: { title: "便捷充值" }
  }
];

/**
 * asyncRoutes
 * 功能页面
 */
export const asyncRoutes = [
  indexRouter,
  adminRouter,
  userRouter,
  rechargePackageRouter,
  queryList,
  amountList,
  rechargeRecord,
  orderManage,
  articleRouter,
  articleCategoryRouter,
  operationRouter,
  userFeed
];

//404 必须放在最底部
export const page404 = [
  {
    path: "*",
    component: () => import("../pages/layout/404.vue"),
    meta: {
      title: "你好像迷路了(｀・ω・´)"
    }
  }
];

const createRouter = () =>
  new Router({
    routes: constantRoutes.concat(asyncRoutes).concat(page404)
  });

export default createRouter();
